import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import gql from "graphql-tag";

@Injectable()
export class ContactInquiryService {
  constructor(private apollo: Apollo) {}

  list(obj?) {
    let variables = {};
    if (obj) {
      variables = {
        first: obj.paginationData.pageSize,
        after:
          obj.paginationData.next === undefined
            ? null
            : obj.paginationData.next.endCursor,
        searchParam: obj.searchParam || null,
      };
    }

    return this.apollo.watchQuery({
      query: gql`
        query GetContactInquiries($first: Int, $after: String, $searchParam: String) {
          contactInquiries(first: $first, after: $after, searchParam: $searchParam) {
            totalCount
            edges {
              node {
                id
                name
                email
                purpose
                source
                createdAt
              }
              cursor
            }
            pageInfo {
              hasNextPage
              endCursor
            }
          }
        }
      `,
      variables: variables,
      errorPolicy: "all",
      fetchPolicy: "network-only",
    }).valueChanges;
  }

  read(id: string) {
    return this.apollo.watchQuery({
      query: gql`
        {
          contactInquiry(id: "${id}") {
            id
            name
            email
            homeCountry
            purpose
            message
            source
            createdAt
          }
        }
      `,
      fetchPolicy: "network-only",
    }).valueChanges;
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/contact-inquiry.service.ts